export default (key) => {
    const search = window.location.search.slice(1);
    let params = search.split('&');
    let values = {};

    params.forEach((str) => {
        const value = str.split('=');

        values[value[0]] = value[1];
    });

    return values[key];
};
